// @flow
import * as React from 'react';

type Info = {
  label: string,
  Icon: any,
  intent?: 'default' | 'primary' | 'success' | 'danger',
};

export const useDelayedProps = (
  initialProps: Info,
  delayedProps: Info,
  launch?: boolean,
  delay: number = 1500,
): Info => {
  const [currentText, setCurrentText] = React.useState<Info>(initialProps);

  const initialTextPropsRef = React.useRef(initialProps);
  const delayedPropsRef = React.useRef(delayedProps);

  initialTextPropsRef.current = initialProps;
  delayedPropsRef.current = delayedProps;

  React.useEffect(() => {
    if (launch === false) {
      setCurrentText(initialTextPropsRef.current);
      return;
    }

    if (launch === undefined || launch === true) {
      setCurrentText(initialTextPropsRef.current);

      const timer = setTimeout(() => {
        setCurrentText(delayedPropsRef.current);
      }, delay);

      // eslint-disable-next-line consistent-return
      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    }
  }, [launch, delay]);

  return currentText;
};
